export const funcList = [
  {
    key: '1',
    title: '绘画模型丰富',
    url: '/images/enterprise-service/pic-synthesis/1.png',
  },
  {
    key: '2',
    title: '图像生成速度快',
    url: '/images/enterprise-service/pic-synthesis/2.png',
  },
  {
    key: '3',
    title: '中英文多语言输入',
    url: '/images/enterprise-service/pic-synthesis/3.png',
  },
  {
    key: '4',
    title: '文生图/图生图',
    url: '/images/enterprise-service/pic-synthesis/4.png',
  },
  {
    key: '5',
    title: '咒语生成器/解析器',
    url: '/images/enterprise-service/pic-synthesis/5.png',
  },
  {
    key: '6',
    title: '多种作画尺寸',
    url: '/images/enterprise-service/pic-synthesis/6.png',
  },
  {
    key: '7',
    title: '图片超分辨/精绘',
    url: '/images/enterprise-service/pic-synthesis/7.png',
  },
  {
    key: '8',
    title: '图像精准控制生成',
    url: '/images/enterprise-service/pic-synthesis/8.png',
  },
]
export const advantageList = [
  {
    key: '1',
    title: '多模型支持',
    desc: '支持基础模型 50+<br />同人角色 / Lora 模型 200+',
    bgColor: 'linear-gradient(116.71deg, #7851EC 8.59%, #320D9E 88.93%)',
  },
  {
    key: '2',
    title: '算力优势',
    desc: '为用户 / 客户提供充足的算力支撑<br />满足快速出图需求',
    bgColor: 'linear-gradient(116.71deg, #45B26B 8.59%, #097930 88.93%)',
  },
  {
    key: '3',
    title: '模型训练',
    desc: '针对不同行业推出专属模型训练<br />根据不同场景生成高质量图像',
    bgColor: 'linear-gradient(116.71deg, #EF466F 8.59%, #A70C31 88.93%)',
  },
  {
    key: '4',
    title: '商业模式',
    desc: '针对不同人群及公司<br />推出积分、包月 / 包年及一次性部署等多种商业合作模式',
    bgColor: 'linear-gradient(116.71deg, #FFD600 8.59%, #957D04 88.93%)',
  },
  {
    key: '5',
    title: '合作案例',
    desc: '和多家企业进行 AI 大赛合作，<br />已成功对接腾讯动漫、中文在线等国民级娱乐平台，更有顶流级动漫IP参与合作',
    bgColor: 'linear-gradient(116.71deg, #DF51EC 8.59%, #7E0489 88.93%)',
  },
]
export const qaList = [
  {
    key: '1',
    title: '基础的 API 使用方式是什么？',
    desc: '1.通过模型列表接口或文档获取无界AI支持的模型编码（model_code）<br />2.通过model_code获取其对应的配置（预设资源），其中关键配置有该模型支持的分辨率、超分倍数、精绘倍数、风格等<br />3.了解基本配置后，通过发起AI作画接口提交作画任务，接口会同步返回任务对应的key列表<br />4.通过key轮询或接收异步回调的方式，获取最终作画结果的图片url<br />5.记得将图片转储到您自己系统的存储服务，我们会在约定的时间过后对url进行清理',
  },
  {
    key: '2',
    title: '当调试API遇到问题时，我如何向平台描述来快速定位原因？',
    desc: '我们每次API的调用，在响应头中都会有TRACE_ID，若您可以将TRACE_ID反馈的话，我们可以快速定位到请求链路。',
  },
  {
    key: '3',
    title: '图片URL会为我们保存多久？',
    desc: '目前的机制是：默认会从出图时起，保存3个月，超过后会被清理。若有更长时间的需求，请联系我们商务沟通。',
  },
  {
    key: '4',
    title:
      '为什么无界AI官网的分辨率和资源接口提供的不一致？为什么创建作画时报“非法参数”？',
    desc: '无界AI产品为了减少用户理解成本，直接提供了“目标分辨率”。而API是为了方便客户灵活组合，拆分了基础分辨率、超分、精绘； 大多数的原因是上送了模型不支持的分辨率导致的，需要通过预设资源接口来确认该模型是否支持您上送的分辨率。',
  },
  {
    key: '5',
    title: '为什么要把图片审核的结果返回给我们？',
    desc: '我们目前支持客户自定义选择包括阿里云、网易易盾的厂商提供审核服务，同时提供了无界AI基于厂商结果的处理结果。如果您希望直接对标无界AI的审核标准，那么可以简单的使用`involve_yellow`字段来判定图片是否违规。如果您有个性化的审核需求，那可以通过审核结果来自行处理。当然您也可以结合自身的审核能力，对图片结果进行再次审核，API这边，无论审核结果是什么，均会将作画的URL返回的。',
  },
  {
    key: '6',
    title:
      '审核会额外收费吗？作画失败的话，会扣积分吗？若作画的结果违规，会扣积分吗？',
    desc: '不会，它的成本已包含在积分中；目前的机制是会先扣，失败的话会退回积分；会的，毕竟它消耗了资源。',
  },
  {
    key: '7',
    title: 'API能支持的QPS是多少？出图的速度是多少？是否支持模型定制？',
    desc: '基准的QPS峰值限制是50，每小时1w张。若您有更高QPS的需求，需要通过商务约定；我们平台平均一张图生成需要10秒左右，具体根据分辨率和模型的不同波动；可以的，请联系商务。',
  },
  {
    key: '8',
    title:
      '我们自己有算力，但希望使用无界AI的能力，如何合作？是否支持私有化部署？',
    desc: '我们支持算力的接入和独占，这样的话，您的绘画成本会低很多；我们支持不同粒度的私有化部署，可以和商务详聊合作。',
  },
]
export const QRCodes = [
  {
    url: '/images/enterprise-service/qrcode/1.png',
    label: '商务合作',
  },
  {
    url: '/images/enterprise-service/qrcode/2.png',
    label: '品牌合作',
  },
]